<template>
  <div>
    <template v-if='isLoading || invoice === null'>
      <v-container>
        <wc-loading line msg='Getting invoice detail'></wc-loading>
      </v-container>
    </template>
    <template v-else>
      <wc-page-title v-if='invoice' :title='title' :subtitle='subtitle'>
        <template v-slot:rightSide>
          <posted-chip :posted='invoice.is_posted'></posted-chip>
          <wc-burger-menu>
            <v-list-item v-if='invoice.is_on_hold'>
              <v-list-item-icon>
                <v-icon color='error'>mdi-cancel</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Remove Hold to Send</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :disabled='noSendToEmail || sendToIsSnailMail' @click='showDialog = true'>
              <v-list-item-icon>
                <v-icon color='info'>mdi-email</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-if='noSendToEmail' class='font-italic'>Contact email address
                  missing</v-list-item-title>
                <v-list-item-title v-if='sendToIsSnailMail' class='font-italic'>Contact is snail mail
                  only</v-list-item-title>
                <v-list-item-title v-else>{{ (invoice.date_sent ? 'Re-e' : 'E') + 'mail invoice' }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if='sendToIsSnailMail' :disabled='!invoice.bill_to_obj.address'
              @click='confirmPrinting = true'>
              <v-list-item-icon>
                <v-icon color='info'>mdi-printer</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-if='invoice.bill_to && !invoice.bill_to_obj.address' class='font-italic'>Contact
                  address not set</v-list-item-title>
                <v-list-item-title v-else>
                  {{ (invoice.date_sent ? 'Re-p' : 'P') + 'rint for snail mail' }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click='showConfirmSendOutstanding = true' v-if='invoice.action_1 && !invoice.is_on_hold'>
              <v-list-item-icon>
                <v-icon color='warning'>mdi-email</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Email Outstanding Notice</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click='arrearsLetter'
              v-if='invoice.action_1 && invoice.action_2 && invoice.action_3 && !invoice.is_on_hold'>
              <v-list-item-icon>
                <v-icon color='error'>mdi-email-newsletter</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Open Arrears Letter</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if='!countdown' @click='toggleSentStatus' :disabled='invoice.is_uncollectible'>
              <v-list-item-icon>
                <v-icon color='orange'>mdi-undo</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-if='invoice.is_posted'>Mark as UN-Sent</v-list-item-title>
                <v-list-item-title v-else>Mark as Sent</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click='downloadInvoice'>
              <v-list-item-icon>
                <v-icon :color='$icons.pdf.color'>{{ $icons.pdf.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Download PDF</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click='previewInvoice'>
              <v-list-item-icon>
                <v-icon color='purple'>mdi-file-find</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Preview</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click='showConfirmToggleUncollectible = true'>
              <v-list-item-icon>
                <v-icon color='warning'>{{ uncollectibleIcon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-if='invoice.is_uncollectible'>Remove UN-collectible Status</v-list-item-title>
                <v-list-item-title v-else>Mark as UN-collectible</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click='toggleArchive' :disabled='invoice.is_posted'>
              <v-list-item-icon>
                <v-icon color='error'>mdi-archive</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-if='!invoice.is_posted'>Toggle Archive</v-list-item-title>
                <v-list-item-title v-else>Cannot Archive Sent Invoice</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </wc-burger-menu>
        </template>
      </wc-page-title>
      <v-container v-if='!invoice.bill_to'>
        <v-alert type='error' border='bottom'>There is no "bill to" set</v-alert>
      </v-container>
      <v-container v-if='invoice.is_on_hold'>
        <v-alert type='error' border='bottom'>Invoice is on hold</v-alert>
      </v-container>
      <v-container v-if='invoice.archived'>
        <v-alert v-if='invoice.archived' type='error' border='bottom'>Invoice is archived</v-alert>
      </v-container>
      <v-container v-if='invoice.is_uncollectible'>
        <v-alert v-if='invoice.is_uncollectible' prominent type='warning' border='right'> Invoice is marked
          UN-collectible</v-alert>
      </v-container>
      <router-view v-if='invoice' :invoice='invoice' @updateInvoice='updateInvoice'
        @newAction='newAction'></router-view>
      <wc-confirm title='Are you sure?' :loading='email_sending' :showDialog='showDialog' @cancel='showDialog = false'
        @confirm='emailToCustomer()'>
        <b>{{ !invoice.resolution || invoice.resolution === "" ? "This invoice has no resolution." : "" }}</b><br>
        {{ (invoice.date_sent ? 'Re-send' : 'Are you sure you are ready to email') + ' this invoice?' }}<br><br>

        <v-divider></v-divider>
        <wc-two-column-table :items="[
          { text: 'Recipient', value: sendTo.name_display },
          { text: 'Email', value: sendTo.email }
        ]"></wc-two-column-table>
        <v-divider></v-divider>
      </wc-confirm>


      <!-- Invoice Printing Reminders -->
      <wc-confirm title='Printing Reminders' icon='mdi-reminder' :showDialog='confirmPrinting' saveText="OK"
        @cancel='confirmPrinting = false' @confirm='printInvoice'>
        Remember when printing:<br>
        <br>
        <ul>
          <li>Turn <strong>OFF</strong> "print headers and footers"</li>
          <li>Turn <strong>ON</strong> "print background"</li>
        </ul>
      </wc-confirm>

      <!-- Confirm Send Outstanding -->
      <wc-confirm title='Send Outstanding Notice?' icon='mdi-email' :showDialog='showConfirmSendOutstanding'
        :loading='email_sending' saveText="Send Outstanding Notice" @cancel='showConfirmSendOutstanding = false'
        @confirm='emailOutstandingNotice'>
        Are you sure you want to send the Outstanding Invoice notice?
      </wc-confirm>

      <!-- Confirm Toggle Uncollectible -->
      <wc-confirm title='Change Uncollectible Status?' :icon='uncollectibleIcon'
        :showDialog='showConfirmToggleUncollectible' :isLoading='isSaving' saveText="Confirm"
        @cancel='showConfirmToggleUncollectible = false' @confirm='confirmToggleUncollectible'>
        <span v-if='invoice.is_uncollectible'>
          Are you sure you want to remove the uncollectible status?
        </span>
        <span v-else>
          Are you sure you want to set this invoice to uncollectible?
        </span>
        <br>
        <br>
        This has large implications for revenue numbers. If you are unsure, please ask management.
      </wc-confirm>


      <!-- Toggle Uncollectible Date -->
      <wc-dialog title='Uncollectible Date?' :icon='uncollectibleIcon' :showDialog='selectToggleUncollectibleDate'
        :isLoading='isSaving' :disableButtons='uncollectibleDate === null' saveText="Confirm" width=350
        @cancel='selectToggleUncollectibleDate = false' @save='toggleUncollectibleStatus'>
        On what date was this invoice determined to be uncollectible?
        <br>
        <wc-datepicker required v-model='uncollectibleDate' :min='invoice.date_due'></wc-datepicker>
        <br>
        This has large implications for revenue numbers. If you are unsure, please ask management.
      </wc-dialog>

      <!-- Confirm Mark Invoice as unsent -->
      <wc-dialog title='Are you sure you want to mark this as UN-sent?' icon='mdi-alert'
        :showDialog='showConfirmMarkAsUnsent'
        :saveText="countdown ? 'Please wait - ' + countdown.toString() : 'Mark as UN-sent'" saveColor='error'
        :disableButtons='!!countdown' @cancel='showConfirmMarkAsUnsent = false' @save='markAsUnsent'>
        Marking this as UN-sent will remove the "POSTED" status and will have larger implications on the accounting
        records.<br><br>
        Please ensure you have been authorized to mark this as un-sent, or you know what you're doing!
      </wc-dialog>
    </template>
    <template v-if='invoice !== null && invoice !== undefined'>
      <v-container>
        <v-row>
          <v-col cols='12' md='4'>
            <basics v-if='invoice' :invoice='invoice' @update='updateInvoice'></basics>
          </v-col>
          <v-col cols='12' md='4'>
            <inv-details v-if='invoice' :invoice='invoice' @update='updateInvoice'></inv-details>
          </v-col>
          <v-col cols='12' md='4'>
            <status ref='status' v-if='invoice' :invoice='invoice'></status>
            <br>
            <hold-box v-if='invoice' :invoice='invoice' @update='updateInvoice' @newAction='newAction'></hold-box>
          </v-col>
        </v-row>

        <v-row class='mt-5'>
          <v-col cols='12'>
            <invoice-lines v-if='invoice' :invoice='invoice' :isSavingLine='isSavingLine' :lines='lines'
              @sortUp='sortUp' @sortDown='sortDown' @updateTotals='updateTotals' @updateLines='updateLines'></invoice-lines>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols='12' md='9'>
            <resolution v-if='invoice' :invoice='invoice' @update='updateInvoice'></resolution>
            <v-btn v-if='showOldCPMLink' info depressed color='info' @click='openOldInvoice'>
              <v-icon small left>mdi-open-in-new</v-icon>
              View on old CPM
            </v-btn>
          </v-col>
          <v-col cols='12' md='3'>
            <invoice-totals v-if='this.invoice !== null && this.invoice !== undefined' :invoice='invoice'
              :lines='lines'></invoice-totals>
          </v-col>
        </v-row>

        <wc-page-section title='Payments and Actions'></wc-page-section>
        <!--
        <v-row class='mt-5'>
          <v-col cols='12'>
            <statement :project='invoice.project_obj'>

            </statement>
          </v-col>
        </v-row>

        <v-row class='mt-5'>
          <v-col cols='12'>
            <progress-invoice :invoice='invoice'>

            </progress-invoice>
          </v-col>
        </v-row>
-->
        <v-row>
          <v-col cols='12' md='6'>
            <payments v-if='invoice' :invoice='invoice' @updateInvoice='updateInvoice' @newAction='newAction'
              @updatePayments='updatePayments'></payments>
          </v-col>
          <v-col cols='12' md='6'>
            <overdue-actions v-if='invoice' :invoice='invoice' @update='updateInvoice'
              @newAction='newAction'></overdue-actions>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <invoice-tracker v-if='this.invoice !== null && this.invoice !== undefined' ref='actionTracker'
      :invoice='invoice'></invoice-tracker>
  </div>
</template>

<script>
import WCBurgerMenu from '@/components/nav/WCBurgerMenu';
import moment from 'moment';
import trackerAPI from '@/api/tracker';
import endpoints from '@/api/endpoints';
import InvoiceTracker from '@/components/trackers/InvoiceTracker';
import WCPosted from '@/components/chips/WCPosted';
import Status from '@/modules/accounting/components/invoice/Status';
import Basics from '@/modules/accounting/components/invoice/Basics';
import Details from '@/modules/accounting/components/invoice/Details';
import InvoiceLines from '@/modules/accounting/components/invoice/InvoiceLines';
import InvoiceHoldBox from '@/modules/accounting/components/invoice/InvoiceHoldBox';
import Totals from '@/modules/accounting/components/invoice/Totals';
import Payments from '@/modules/accounting/components/invoice/Payments';
import OverdueActions from '@/modules/accounting/components/invoice/OverdueActions';
import Resolution from '@/modules/accounting/components/invoice/Resolution';
//import ProgressInvoice from '@/modules/accounting/components/invoice/ProgressInvoice';
//import Statement from '@/modules/accounting/components/invoice/Statement';
import accountingAPI from '@/api/accounting';

export default {
  name: 'invoice-detail',
  data: () => ({
    email_sending: false,
    isSavingLine: false,
    lines: [],
    isLoading: true,
    isSaving: false,
    showDialog: false,
    showConfirmSendOutstanding: false,
    showConfirmMarkAsUnsent: false,
    showConfirmToggleUncollectible: false,
    selectToggleUncollectibleDate: false,
    uncollectibleDate: null,
    confirmPrinting: false,
    invoice: null,
    interval: 0,
    countdown: 0,
    uncollectibleIcon: 'mdi-alert-octagon-outline'
  }),
  computed: {
    tax() {
      return this.invoice.original_amount - (this.invoice.original_amount / (1 + this.$store.state.misc.settings.tax_rate_perc));
    },
    total() {
      return this.invoice.original_amount;
    },
    subtotal() {
      return this.invoice.original_amount / (1 + this.$store.state.misc.settings.tax_rate_perc);
    },
    showOldCPMLink() {
      let pattern = /^[A-Z][A-Z][A-Z]-.*$/
      if (this.invoice === null || this.invoice === undefined) {
        return false;
      }
      if (pattern.test(this.invoice.number)) {
        return false;
      }
      return true;
    },
    title() {
      if (this.invoice.number) {
        return 'Invoice #: ' + this.invoice.number
      }
      return 'Invoice #: ?'
    },
    subtitle() {
      if (this.invoice.bill_to) {
        return this.invoice.bill_to_obj.name_display
      }
      return 'Bill to ?'
    },
    sendTo() {
      // This is the contact to send the email to. It's also used
      // in the confirmation window before actually emailing.
      if (this.invoice.send_to) {
        return this.invoice.send_to_obj
      }
      if (this.invoice.bill_to) {
        return this.invoice.bill_to_obj
      }
      return { name_display: "", email: "" }
    },
    noSendToEmail() {
      if (this.invoice) {
        if (this.invoice.send_to) {
          if (this.invoice.send_to_obj.email) {
            return false
          }
        } else if (this.invoice.bill_to) {
          if (this.invoice.bill_to_obj.email) {
            return false
          }
        }
      }
      return true
    },
    noSendTo() {
      if (this.invoice) {
        if (this.invoice.send_to) {
          if (this.invoice.send_to_obj.email) {
            return false
          }
        } else if (this.invoice.bill_to) {
          if (this.invoice.bill_to_obj.email) {
            return false
          }
        }
      }
      return true
    },
    sendToIsSnailMail() {
      if (this.invoice) {
        if (this.invoice.send_to) {
          if (this.invoice.send_to_obj.snail_mail_only) {
            return true
          }
        } else if (this.invoice.bill_to) {
          if (this.invoice.bill_to_obj.snail_mail_only) {
            return true
          }
        }
      }
      return false
    },
    sendToMissing() {
      if (this.invoice) {
        if (this.invoice.send_to) {
          if (this.invoice.send_to_obj.snail_mail_only) {
            return true
          }
        } else if (this.invoice.bill_to) {
          if (this.invoice.bill_to_obj.snail_mail_only) {
            return true
          }
        }
      }
      return false
    },
    menu() {
      return [
        {
          title: this.$store.state.icons.routes.overview.title,
          icon: this.$store.state.icons.routes.overview.icon,
          route: { name: 'InvoiceOverview', params: { id: this.$route.params.id } }
        }
      ]
    }
  },
  created() {
    this.getInvoiceLines();
    this.getInvoice();
  },
  watch: {
    $route() {
      this.getInvoiceLines();
      this.getInvoice();
    }
  },
  methods: {
    async updateInvoice(id, invoice) {
      this.invoice = await accountingAPI.updateInvoice(id, invoice);
    },
    async getInvoiceLines() {
      this.isLoading = true;
      this.lines = await accountingAPI.getLineItems(this.$route.params.id);
      this.isLoading = false;
    },
    async updateInvoiceLinesOrderOnly() {
      let linesArray = [];
      this.lines.forEach(line => linesArray.push(line.id));
      await accountingAPI.updateInvoiceLineItemOrder(linesArray);
    },
    openOldInvoice() {
      window.open('http://23.239.3.86/accounting/view-details/' + this.invoice.number + '/', '_blank');
    },
    sortUp(line, index) {
      this.lines.splice(index, 1);
      this.lines.splice(index - 1, 0, line);
      this.updateInvoiceLinesOrderOnly();
    },
    sortDown(line, index) {
      this.lines.splice(index, 1);
      this.lines.splice(index + 1, 0, line);
      this.updateInvoiceLinesOrderOnly();
    },
    updatePayments(change) {
      this.invoice.payments = this.invoice.payments - change;
      this.invoice.amount_os = this.invoice.amount_os + change;
    },
    updateTotals(change) {
      this.invoice.amount_os = this.invoice.amount_os += change;
      this.invoice.original_amount = this.invoice.original_amount += change;
    },
    async getInvoice() {
      this.isLoading = true;
      this.invoice = await accountingAPI.getInvoice(this.$route.params.id);
      this.$store.dispatch('loadSubnavTitle', this.title);
      this.$store.dispatch('loadSubnav', this.menu);
      this.isLoading = false;
    },
    async toggleSentStatus() {
      if (this.invoice.date_sent) {
        this.showConfirmMarkAsUnsent = true;
        this.runTimer();
      } else {
        this.invoice.date_sent = moment().format('YYYY-MM-DD').toString()
        this.invoice.date_due = moment().format('YYYY-MM-DD').toString()

        this.addInvoiceTracker(
          this.invoice.id,
          this.$store.state.auth.profile.id,
          moment().format('YYYY-MM-DD').toString(),
          'Invoice marked as sent'
        );
        accountingAPI.postInvoice(this.invoice.id, this.invoice);
        this.invoice.is_posted = true;
      }
    },
    async markAsUnsent() {
      this.invoice.date_sent = null
      this.invoice.date_due = null

      this.addInvoiceTracker(
        this.invoice.id,
        this.$store.state.auth.profile.id,
        moment().format('YYYY-MM-DD').toString(),
        "Removed 'sent' status"
      );
      this.invoice.is_posted = false;
      accountingAPI.unpostInvoice(this.invoice.id, this.invoice);
      this.showConfirmMarkAsUnsent = false;
    },
    async toggleArchive() {
      let actionMsg = '';
      if (this.invoice.archived) {
        actionMsg = "Removed 'archived' status"
        this.invoice.archived = false
      } else {
        actionMsg = 'Invoice archived'
        this.invoice.archived = true
      }

      this.updateInvoice(this.invoice.id, this.invoice);
      this.addInvoiceTracker(
        this.invoice.id,
        this.$store.state.auth.profile.id,
        moment().format('YYYY-MM-DD').toString(),
        actionMsg
      );
    },
    confirmToggleUncollectible() {
      if (this.invoice.is_uncollectible) {
        this.toggleUncollectibleStatus();
      } else {
        this.selectToggleUncollectibleDate = true;
      }
    },
    async toggleUncollectibleStatus() {
      this.isSaving = true;
      let actionMsg = '';
      if (this.invoice.is_uncollectible) {
        actionMsg = "Removed 'uncollectible' status";
        this.invoice.is_uncollectible = false;
      } else {
        actionMsg = 'Invoice marked as UN-collectible as at ' + this.$options.filters.shortDate(this.uncollectibleDate);
        this.invoice.is_uncollectible = true;
      }

      if (this.uncollectibleDate === null || this.uncollectibleDate === undefined) {
        this.uncollectibleDate = moment().format('YYYY-MM-DD').toString();
      }

      await accountingAPI.toggleInvoiceUncollectible(this.invoice.id, this.uncollectibleDate, this.invoice.is_uncollectible);
      this.showConfirmToggleUncollectible = false;

      this.addInvoiceTracker(
        this.invoice.id,
        this.$store.state.auth.profile.id,
        moment().format('YYYY-MM-DD').toString(),
        actionMsg
      );

      this.selectToggleUncollectibleDate = false;
      this.isSaving = false;
    },
    async emailToCustomer() {
      this.email_sending = true;
      let description = '';

      if (!this.invoice.date_sent) {
        description = 'Invoice emailed to customer at ' + this.sendTo.email
      } else {
        description = 'Invoice emailed again at ' + this.sendTo.email
      }

      this.addInvoiceTracker(
        this.invoice.id,
        this.$store.state.auth.profile.id,
        moment().format('YYYY-MM-DD').toString(),
        description
      );
      this.invoice = await accountingAPI.emailInvoice(this.invoice.id);
      this.email_sending = false;
      this.showDialog = false;
    },
    async emailOutstandingNotice() {
      this.email_sending = true;
      this.invoice = await accountingAPI.emailInvoiceOutstandingNotice(this.invoice.id, 'outstanding-invoice');

      this.addInvoiceTracker(
        this.invoice.id,
        this.$store.state.auth.profile.id,
        moment().format('YYYY-MM-DD').toString(),
        'ACTION 1 -- Outstanding Notice emailed to customer'
      );

      this.email_sending = false;
      this.showConfirmSendOutstanding = false;
    },

    downloadInvoice() {
      const link = document.createElement('a')
      const previewURL = this.$axios.defaults.baseURL + endpoints.downloadInvoice + this.invoice.id
      link.target = '_blank'
      link.href = previewURL
      link.click()
    },
    previewInvoice() {
      const link = document.createElement('a')
      const previewURL = this.$axios.defaults.baseURL + endpoints.previewInvoice + this.invoice.id
      link.target = '_blank'
      link.href = previewURL
      link.click()
      this.confirmPreview = false
    },
    arrearsLetter() {
      const link = document.createElement('a')
      const letterURL = this.$axios.defaults.baseURL + endpoints.arrearsLetter + this.invoice.id
      link.target = '_blank'
      link.href = letterURL
      link.click()
      this.confirmPreview = false
    },
    async printInvoice() {
      let description = '';

      if (!this.invoice.date_due) {
        this.invoice.date_sent = moment().format('YYYY-MM-DD').toString();
        this.invoice.date_due = moment().format('YYYY-MM-DD').toString();
        description = 'Invoice printed for mailing to customer';
      } else {
        description = 'Invoice printed again';
      }

      this.addInvoiceTracker(
        this.invoice.id,
        this.$store.state.auth.profile.id,
        moment().format('YYYY-MM-DD').toString(),
        description
      );

      this.updateInvoice(this.invoice.id, this.invoice);
      this.previewInvoice();
      this.confirmPrinting = false;
    },
    newAction(response) {
      this.$refs.actionTracker.pushItem(response);
    },
    calcDuration() {
      if (this.countdown === 0) {
        clearInterval(this.interval)
      } else {
        this.countdown = this.countdown - 1
      }
    },
    runTimer() {
      this.countdown = 5
      this.interval = setInterval(() => { this.calcDuration() }, 1000)
    },
    updateLines(lines){
      this.lines = lines;
    },
    async addInvoiceTracker(id, taken_by, action_date, description) {
      const tracker = {
        'tracker_data': {
          'taken_by': taken_by,
          'action_date': action_date,
          'description': description
        },
        'invoice': this.invoice.id
      }
      const new_tracker = await trackerAPI.createInvoiceTracker(tracker);
      this.$refs.actionTracker.pushItem(new_tracker);
      return new_tracker;
    }
  },
  components: {
    'basics': Basics,
    'inv-details': Details,
    'hold-box': InvoiceHoldBox,
    'status': Status,
    'invoice-lines': InvoiceLines,
    'invoice-totals': Totals,
    'payments': Payments,
    'resolution': Resolution,
    'overdue-actions': OverdueActions,
    'wc-burger-menu': WCBurgerMenu,
    'invoice-tracker': InvoiceTracker,
    'posted-chip': WCPosted,
    //'progress-invoice': ProgressInvoice,
    //'statement': Statement
  }
}
</script>
